module.exports = __webpack_public_path__ + "img/evaluation_icon.32617cc6.png";